import { HttpResponse } from "@angular/common/http";
import { of } from "rxjs";
import { Cultures } from "../models/cultures.enum";

export const  stringIsNotNullOrEmpty = (str: any): boolean  => str?.length > 0;

export const okHttpResponse = (body: any = null) => of(new HttpResponse({ status: 200, body: body }))

export * as Utility from './utility-helper';

export const NeutralLanguageMappingInfo: { [id: string]: string; } =
{
  en: Cultures.EnUs,
  fr: Cultures.FrCa,
  es: Cultures.EsEs,
  cs: Cultures.CsCz,
  de: Cultures.DeDe

};

export const DefaultDecimalSeparator = '.';

export function Timeout(seconds: number) {
  return new Promise(function (resolve) {
    setTimeout(resolve, seconds * 1000);
  });
}
